import { ButtonGroup, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import {
  MARGIN_R_20,
  POINTER,
  PRINT_CHECK_DATA,
  PRINT_DROPDOWN_DATA,
  RIGHT_ALIGN,
} from "../../utils/GlobalConstants";
import { getDateFromTS } from "../../utils/genericUse/CommonUse";
import ButtonView from "../common/button/ButtonView";
import CheckboxView from "../common/checkbox/CheckboxView";
import DataPicker from "../common/datePicker/DataPicker";
import { SelectView } from "../common/selectView/SelectView";
import TextInput from "../common/textInput/TextInput";
import LocalPrintshopOutlinedIcon from "@mui/icons-material/LocalPrintshopOutlined";

const PrintDialogView = (props) => {
  const [selectedSurvey, setSelectedSurvey] = useState(props.selectedSurvey);
  const [selectedChoice, setSelectedChoice] = useState({
    Sort_by: 1,
    then_by_Sort: 0,
    then_by: 0,
    comment: "",
  });
  const [itemsCheck, setItemsCheck] = useState(PRINT_CHECK_DATA);

  useEffect(() => {
    setSelectedSurvey(props.selectedSurvey);
  }, [props.selectedSurvey]);

  const onHandleChangeUser = (item, type) => {
    if (type === "Sort_by") {
      setSelectedChoice((data) => ({ ...data, Sort_by: item }));
    } else if (type === "then_by_Sort") {
      setSelectedChoice((data) => ({ ...data, then_by_Sort: item }));
    } else if (type === "then_by") {
      setSelectedChoice((data) => ({ ...data, then_by: item }));
    } else {
      //do nothing
    }
  };

  const onChangeComment = (e) => {
    setSelectedChoice((data) => ({ ...data, comment: e.target.value }));
  };

  const onCheck = (e, data) => {
    for (let i = 0; i < itemsCheck.length; i++) {
      if (itemsCheck[i].id === data.id) {
        itemsCheck[i].checked = e.target.checked;
        setItemsCheck((itemsCheck) => [...itemsCheck]);
      }
    }
  };

  return (
    <React.Fragment>
      <Grid container className="centerAlignment" spacing={2}>
        <Grid item md={4} sm={6} lg={4} xs={6}>
          <SelectView
            data={PRINT_DROPDOWN_DATA}
            label={"Sort By"}
            onHandleChange={(item) => onHandleChangeUser(item, "Sort_by")}
            value={selectedChoice.Sort_by}
            testid={"sort_by"}
          />
        </Grid>
        <Grid item md={4} sm={6} lg={4} xs={6}>
          <SelectView
            data={PRINT_DROPDOWN_DATA}
            label={"then by"}
            onHandleChange={(item) => onHandleChangeUser(item, "then_by_Sort")}
            value={selectedChoice.then_by_Sort}
            testid={"then_by_sort"}
          />
        </Grid>
        <Grid item md={4} sm={6} lg={4} xs={6}>
          <SelectView
            data={PRINT_DROPDOWN_DATA}
            label={"then by"}
            onHandleChange={(item) => onHandleChangeUser(item, "then_by")}
            value={selectedChoice.then_by}
            testid={"then_by"}
          />
        </Grid>
      </Grid>
      <Grid container className="centerAlignment" spacing={2}>
        <Grid item md={4} sm={6} lg={4} xs={6}>
          <TextInput
            label={"Your Comments"}
            multiline={true}
            name={"comments"}
            onChange={(e) => onChangeComment(e)}
            value={selectedChoice.comments}
          />
        </Grid>
        <Grid item md={4} sm={6} lg={4} xs={6}>
          <DataPicker
            label={"Date Created"}
            value={
              selectedSurvey
                ? getDateFromTS(selectedSurvey.createdTs)
                : new Date()
            }
            readOnly
          />
        </Grid>
        <Grid item md={4} sm={6} lg={4} xs={6}>
          <DataPicker
            label={"Date Revised"}
            value={
              selectedSurvey
                ? getDateFromTS(selectedSurvey.lastUpdatedTs)
                : new Date()
            }
          />
        </Grid>
      </Grid>
      <Grid container className="centerAlignment" spacing={2}>
        {itemsCheck.map((data, i) => {
          return (
            <Grid item md={4} sm={6} lg={4} xs={6} key={i}>
              <CheckboxView
                testid="check"
                label={data.label}
                checked={data.checked}
                onCheck={(e) => onCheck(e, data)}
              />
            </Grid>
          );
        })}
      </Grid>
      <Grid container>
        <Grid item md={12} lg={12} xs={12} sm={6}>
          <ButtonGroup variant="outlined" style={RIGHT_ALIGN}>
            <LocalPrintshopOutlinedIcon
              className="surveyIconsStyle-bg"
              style={{ ...MARGIN_R_20, ...POINTER }}
              testid={"print"}
              onClick={() => props.handlePrint(selectedChoice, itemsCheck)}
            />
            <ButtonView
              label={"Exit"}
              onClick={() => props.handleClose()}
              testid={"exit_print"}
            />
          </ButtonGroup>
        </Grid>
      </Grid>
    </React.Fragment>
  );
};
export default PrintDialogView;
